import randomToken from './random-token';

const DEFAULT_TOKEN_SIZE = 12;

export interface Action<T, P> {
  id: string;
  type: T;
  payload: P;
}

export interface Draft<T, P> extends Action<T, P> {
  idDraft: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function actionCreator<A extends Action<symbol, any>>(type: A['type']) {
  function creator(): Action<A['type'], null>;
  function creator(payload: A['payload']): A;
  function creator(
    payload?: A['payload'],
  ): Action<A['type'], A['payload'] | null> {
    return {
      // Uniquely identify an action.  This gets used by the sync process for
      // pending actions
      id: randomToken(DEFAULT_TOKEN_SIZE),
      payload: typeof payload === 'undefined' ? null : payload,
      type,
    };
  }

  return creator;
}

export function makeDraft<T, P>(
  idDraft: string,
  action: Action<T, P>,
): Draft<T, P> {
  return {
    ...action,
    idDraft,
  };
}



// WEBPACK FOOTER //
// ./app/gamma/src/util/actions.ts